import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { firestore } from '../../../firebase'
import StateContext from '../../../StateContext'
import AddPlayerSquadSeason from '../../Admin/Team/templates/AddPlayerSquadSeason'

import './Player.css'
import TeamSquadListTemplate from './templates/TeamSquadListTemplate'

function TeamSquad({teamId, mode}) {

    const {loggedIn} = useContext(StateContext)

    const CURRENT_SEASON = new Date().getFullYear()
    const SEASONS = [2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021]

    const appState = useContext(StateContext)
    const [players, setPlayers] = useState([])
    const [playersFiltered, setPlayersFiltered] = useState([])

    const [season, setSeason] = useState(CURRENT_SEASON)

    useEffect(() => {

        try {
            const teamRef = firestore.collection("teams").doc(teamId).collection("team-squads");
            teamRef.where("season", "==", season).onSnapshot(({docs}) => {
                const players = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                //console.log(players)
                setPlayers(players)
                const filteredPlayersInitial = players.filter((player) => player.season === +season)
                setPlayersFiltered(filteredPlayersInitial)
            })
        } catch (error) {
            
        }

    }, [teamId, season])

    useEffect(() => {
        if (season) {
            const filteredPlayers = players.filter((player, index) => player.season === +season)
            setPlayersFiltered(filteredPlayers)
        }
    }, [season])

    function changeSeasonHandler(e) {
        setSeason(e.target.value)
    }

    return (
        <React.Fragment>
            <div className="row my-4">
                {SEASONS.map((curSeason) => {
                    return <div className="col-2 col-lg-1">
                        <button className={`text-white btn-block ${season === curSeason ? "bg-success" : "bg-primary"}`} onClick={() => setSeason(curSeason)}>{curSeason}</button>
                    </div>
                })}
            </div>
            <div className="row">
                {players?.map((player, index) => {
                    return <TeamSquadListTemplate player={player} mode={mode} key={index} teamId={teamId} />
                })}
            </div>
            {loggedIn && <AddPlayerSquadSeason teamId={teamId} squad={players} season={season} />}
            
        </React.Fragment>

    )
}
export default TeamSquad